import { useEffect, useState } from 'react'

type CountdownTime = {
  startTime: Date
  endTime: Date
  days: number
  hours: number
  minutes: number
  seconds: number
}

export const useTodayCountdown = (): CountdownTime => {
  const calculateCountdown = (): CountdownTime => {
    const now = new Date()
    const end = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      59,
      59,
      0
    )
    const diffSeconds = Math.max(
      0,
      Math.floor((end.getTime() - now.getTime()) / 1000)
    )
    const days = Math.floor(diffSeconds / 86400)
    const hours = Math.floor(diffSeconds / 3600)
    const minutes = Math.floor((diffSeconds % 3600) / 60)
    const seconds = diffSeconds % 60

    return {
      startTime: now,
      endTime: end,
      days,
      hours,
      minutes,
      seconds
    }
  }

  const [countdown, setCountdown] = useState<CountdownTime>(calculateCountdown)

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(calculateCountdown())
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return countdown
}
